import { QueryHookOptions } from '@apollo/client';

import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  KioskAssetFilter,
  useKioskAssetsQuery,
  KioskAssetsQuery,
  KioskAssetFragment,
} from '@occc/graphql';

type GetKioskAssetsProps = {
  filter: KioskAssetFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const transformDataToAssetsArray = (
  data?: KioskAssetsQuery,
): KioskAssetFragment[] | undefined => data?.kioskAssets?.edges?.map((e) => e.node);

export const useGetKioskAssets = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetKioskAssetsProps) => {
  const response = usePaginatedQuery(
    useKioskAssetsQuery,
    'kioskAssets.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
    } as QueryHookOptions,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: transformDataToAssetsArray(response.data),
  };
};
